
import { Watch, Vue, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import Passenger, { PassengerState } from "../models/Passenger";
import vuetifyToast from "vuetify-toast";
import Helpers from "../../../util/Helpers";
import "./PassengerList.scss";
import { Group } from "@/components/Passenger/models/Group";
import GroupPicker from "./GroupPicker.vue";
import { PassengerDialog } from "@/components/Passenger/components/PassengerDialog.vue";
import Routes from "../../../Routes";
import Trip from "../models/Trip";

@Component({
  components: {
    GroupPicker
  }
})
export class PassengerListRow extends Vue {

  @Prop({ required: true })
  passenger!: Passenger;

  @Prop({ default: false })
  pickMode: boolean;

  @Prop({ default: () => []})
  allTrips: Trip[];

  @Prop({ default: () => []})
  destinationGroups: Group[];

  @Prop({ default: false})
  showTripsColumn: boolean;

  @Prop({ default: false})
  userCanEditGroups: boolean;
   
  @Prop({ default: false})
  userCanEditPassengers: boolean;
   
  @Prop({ default: false})
  userCanDeletePassengers: boolean;


  groupNamesToFilterIn: string[] = [];
  groupNamesToAssign: string[] = [];
  groupNamesToAssignForSinglePassenger: string[] = [];
  savingPassengerGroups: boolean = false;
  
  constructor() {
    super();
  }

  get passengerGroupNames(): string[] {
    if (!this.passenger.groups){
      return [""];
    }
    return this.passenger.groups.split(",").map(g => g.trim());
  }

  get helpers() {
    return Helpers;
  }

  get activeTripsForPassenger(): number {
    return this.allTrips
      .filter((t) => t.passengerId === this.passenger.id)
      .filter((t) => !t.cancelledAt).length;
  }

  get userCanSeeActionsColumn(): boolean {
    return this.userCanEditPassengers && this.userCanDeletePassengers;
  }

  get passengerHasAddableGroups(): boolean {
    if (this.groupNamesToAssign.length === 0) {
      return false;
    }
    const passengerGroupNames = this.passenger.groups.split(",").map(g => g.trim());
    return !this.groupNamesToAssign.every(gn =>
      passengerGroupNames.includes(gn)
    );
  }

  async savePassengerGroups(passenger) {
    try {
      await this.$store.dispatch("passenger/updatePassengerGroups", {
        params: { id: passenger.id },
        data: passenger
      });
    } catch (ex) {
      vuetifyToast.error(
        this.$i18n.translate(
          "passenger.save.error.generic",
          "There was an error saving the passenger. Please try again later."
        )
      );
    }
  }

  onAddGroupClick(passenger: Passenger) {
    this.$emit("addGroupClick", passenger);
  }

  async onGroupCellClick(passenger: Passenger) {
    if (passenger.inactive) {
      return;
    }
    if (this.pickMode) {
      this.toggleItemPicked(passenger, !passenger.picked);
    } else {
      const modified = passenger.addToGroupNames(this.groupNamesToAssign);
      if (!modified) {
        return;
      }
      await this.savePassengerGroups(passenger);
    }
  }

  async onGroupChipClick(passenger: Passenger, groupName: string) {
    return;
  }

  async onGroupChipInput(passenger: Passenger, groupName: string) {
    if (this.pickMode) {
      return;
    }
    const modified = passenger.removeFromGroupNames([groupName]);
    if (!modified) {
      return;
    }
    await this.savePassengerGroups(passenger);
  }

  toggleItemPicked(passenger: Passenger, value) {
    this.$emit("toggleItemPicked", { passenger, value });
  }

  onPassengerClick(event: Event, passenger: Passenger) {
    this.$root.$emit(PassengerDialog.EVENT_PASSENGER_DIALOG_SHOW, passenger);
  }

  async created(){
   
  }

  beforeDestroy() {
   
  }
}

export default PassengerListRow;
